import React, { useCallback, useMemo, useState } from "react";
import debounce from "lodash/debounce";

const DebounceWithState = () => {
  const [search, setSearchValue] = useState();

  const sendRequest = useCallback((value) => {
    console.log("changed value", value);
  }, []);

  const debouncedSendRequest = useMemo(() => {
    return debounce(sendRequest, 1000);
  }, [sendRequest]);

  const onChange = (e) => {
    const value = e.target.value;
    setSearchValue(value);
    debouncedSendRequest(value);
  };
  return (
    <div>
      DebounceWithState
      <input onChange={onChange} value={search} />
      <button
        onClick={() => {
          setSearchValue("");
          debouncedSendRequest(null);
        }}
      >
        Reset
      </button>
    </div>
  );
};

export default DebounceWithState;
